import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Radio } from "antd";
import InputComponent from "./InputComponent";
import { EmailWrapper } from "../../Step1Setup/styles";
import { MarginSpecific } from "./styles";
import { ErrMargin, MarginComponentDrop, EmailTitleWrapperFont, SpanWrap } from "../styles";
import validate from "../../../../../utils/validations";
import regexMap from "../../../../../utils/regexMap";
import SelectComponent from "./SelectComponent";
import { SelectComponentWrap } from "./Tabs/styles";
import { RadioButtonWrapper } from "../../../../NPA/Pages/Step1Setup/styles";
import FormItem from "antd/lib/form/FormItem";
import { RadioButton } from "../../../../../CommonComponents/commonStyles";

export default class CharityBasicInfo extends React.Component {
                 constructor(props) {
                   super(props);                   
                   this.state = {
                     charityName: {
                       value: props.charityData.name || "",
                       touched: false,
                       valid: "",
                       matchPattern: regexMap.charityName,
                       validationRules: {
                         isRequired: true,
                         minLength: 2
                       },
                       messages: {
                         isRequired: "Please enter charity name for charity to continue",
                         minLength: "Charity name of charity is too short. Please correct to proceed"
                       }
                     },
                     contactFirstName: {
                       value: props.charityData.contactFirstName || "",
                       touched: false,
                       valid: "",
                       matchPattern: regexMap.name,
                       validationRules: {}
                     },
                     contactLastName: {
                       value: props.charityData.contactLastName || "",
                       touched: false,
                       valid: "",
                       matchPattern: regexMap.name,
                       validationRules: {}
                     },
                     contactEmail: {
                       value: props.charityData.contactEmail || "",
                       touched: false,
                       valid: "",
                       matchPattern: regexMap.name,
                       validationRules: {
                         matchPattern: regexMap.email
                       },
                       messages: {
                         matchPattern: "Invalid email format"
                       }
                     },
                     charityAllocPercent: {
                       value: props.charityData.charityAllocPercent ? parseFloat(props.charityData.charityAllocPercent).toFixed(2) : "",
                       touched: false,
                       valid: "",
                       matchPattern: regexMap.twoDecimal,
                       validationRules: {
                         isRequired: true
                       },
                       messages: {
                         isRequired: "Please enter % of charity"
                       }
                     },
                     grantRecognition: {
                       value: props.charityData.grantRecognition || "",
                       touched: false,
                       valid: "",
                       validationRules: {
                         isRequired: true
                       },
                       messages: {
                         isRequired: "Grant recognition required"
                       }
                     },
                     grantPurpose: {
                       value:
                         (props.charityData.grantPurpose === "Area of most need" || props.charityData.grantPurpose === 'AOMN')
                           ? "AOMN"
                           : props.charityData.otherGrantPurposeText || "",
                       touched: false,
                       valid: "",
                       matchPattern: regexMap.name,
                       validationRules: {
                         isRequired: true
                       },
                       messages: {
                         isRequired: "Grant purpose required"
                       }
                     },
                     phone: {
                       value: props.charityData.contactPhone || "",
                       touched: false,
                       valid: ""
                     },
                     webAddress: {
                       value: props.charityData.webAddress || "",
                       touched: false,
                       valid: "",
                       matchPattern: regexMap.name
                     },

                     ein: {
                       value: props.charityData.ein || "",
                       touched: false,
                       valid: "",
                       matchPattern: /^[0-9,-]{0,10}$/
                     },
                     grantRadio: {
                       value: props.charityData.grantPurpose
                         ? (props.charityData.grantPurpose === "Area of most need" || props.charityData.grantPurpose === 'AOMN')
                           ? "AOMN"
                           : "OTHER"
                         : null,
                       validationRules: {}
                     }
                   };
                 }

                 componentDidMount() {
                   this.handleFormChange();
                 }

                 componentWillReceiveProps(props) {                  
                   this.setState(
                     {
                       charityName: {
                         ...this.state.charityName,
                         value: props.charityData.name || ""
                       },
                       contactFirstName: {
                         ...this.state.contactFirstName,
                         value: props.charityData.contactFirstName || ""
                       },
                       contactLastName: {
                         ...this.state.contactLastName,
                         value: props.charityData.contactLastName || ""
                       },
                       contactEmail: {
                         ...this.state.contactEmail,
                         value: props.charityData.contactEmail || ""
                       },
                       charityAllocPercent: {
                         ...this.state.charityAllocPercent,
                         value: props.charityData.charityAllocPercent || ""
                       },
                       grantRecognition: {
                         ...this.state.grantRecognition,
                         value: props.charityData.grantRecognition || ""
                       },
                       grantPurpose: {
                         ...this.state.grantPurpose,
                         value:
                            (props.charityData.grantPurpose === "Area of most need" || props.charityData.grantPurpose === 'AOMN')
                             ? "AOMN"
                             : props.charityData.otherGrantPurposeText || ""
                       },
                       phone: {
                         value: props.charityData.contactPhone || "",
                         touched: false,
                         valid: ""
                       },
                       webAddress: {
                         value: props.charityData.webAddress || "",
                         touched: false,
                         valid: "",
                         matchPattern: regexMap.name
                       },

                       ein: {
                         value: props.charityData.ein || "",
                         touched: false,
                         valid: "",
                         matchPattern: /^[0-9,-]{0,10}$/
                       },
                       grantRadio: {
                         value: props.charityData.grantPurpose
                           ? (props.charityData.grantPurpose === "Area of most need" || props.charityData.grantPurpose === 'AOMN')
                             ? "AOMN"
                             : "OTHER"
                           : null,
                         validationRules: {}
                       }
                     },
                     () => {
                       if (props.validateForm) {
                         this.runFormValidation();
                       }
                     }
                   );
                 }

                 componentDidUpdate(prevProps) {
                   if (this.props.legacyFormValid && prevProps.legacyFormValid !== this.props.legacyFormValid) {
                     const updatedFormElement = {
                       ...this.state
                     };
                     for (const inputIdentifier of Object.keys(updatedFormElement)) {
                       if (
                         updatedFormElement[inputIdentifier].validationRules &&
                         Object.keys(updatedFormElement[inputIdentifier].validationRules).length
                       ) {
                         updatedFormElement[inputIdentifier].touched = false;
                       }
                     }
                     this.setState({
                       ...updatedFormElement
                     });
                   }
                 }
                 runFormValidation = () => {
                   const updatedFormElement = {
                     ...this.state
                   };
                   for (const inputIdentifier of Object.keys(updatedFormElement)) {
                     if (
                       updatedFormElement[inputIdentifier].validationRules &&
                       Object.keys(updatedFormElement[inputIdentifier].validationRules).length
                     ) {
                       updatedFormElement[inputIdentifier].valid = validate(
                         updatedFormElement[inputIdentifier].value.trim(),
                         updatedFormElement[inputIdentifier].validationRules
                       );
                       updatedFormElement[inputIdentifier].touched = true;
                     }
                   }
                   this.setState({
                     ...updatedFormElement
                   });
                 };

                 handleBlur = event => {
                   const name = event.target.name;
                   const value = event.target.value;
                   const updatedFormElement = {
                     ...this.state[name]
                   };
                   updatedFormElement.valid = validate(value.trim(), updatedFormElement.validationRules);
                   if(name === "charityAllocPercent"){
                   updatedFormElement.value = value ? parseFloat(value).toFixed(2): '';
                   }

                   this.setState({
                     [name]: updatedFormElement
                   });
                 };
                 selectChange = (value, name) => {
                   const updatedFormElement = {
                     ...this.state[name]
                   };
                   updatedFormElement.value = value;
                   updatedFormElement.touched = true;
                   updatedFormElement.valid = "";
                   this.setState(
                     {
                       [name]: updatedFormElement
                     },
                     this.handleFormChange
                   );
                 };
                 handleChange = event => {
                   const name = event.target.name;
                   const value = event.target.value;
                   const updatedFormElement = {
                     ...this.state[name]
                   };
                   const matched = updatedFormElement.matchPattern ? updatedFormElement.matchPattern.test(value) : true;
                   if (matched) {
                     updatedFormElement.value = value.trimLeft();
                     updatedFormElement.touched = true;
                     updatedFormElement.valid = "";
                     this.setState(
                       {
                         [name]: updatedFormElement
                       },
                       this.handleFormChange
                     );
                   }
                 };

                 checkFormValid = state => {
                   let formIsValid = true;
                   for (let inputIdentifier of Object.keys(state)) {
                     if (
                       state[inputIdentifier].validationRules &&
                       Object.keys(state[inputIdentifier].validationRules).length
                     ) {
                       formIsValid =
                         !validate(state[inputIdentifier].value, state[inputIdentifier].validationRules) && formIsValid;
                     }
                   }
                   return formIsValid;
                 };

                 // format data before passing it back
                 formatData = () => {
                   return {
                     data: {
                       name: this.state.charityName.value,
                       charityAllocPercent: this.state.charityAllocPercent.value,
                       grantRecognition: this.state.grantRecognition.value,
                       grantPurpose: this.state.grantRadio.value,
                       contactPhone: this.state.phone.value,
                       webAddress: this.state.webAddress.value,
                       ein: this.state.ein.value,
                       otherGrantPurposeText: this.state.grantPurpose.value,
                       contactFirstName: this.state.contactFirstName.value,
                       contactLastName: this.state.contactLastName.value,
                       contactEmail: this.state.contactEmail.value
                     },
                     isFormValid: this.checkFormValid(this.state)
                   };
                 };

                 showError = elem => {
                   return elem.touched && elem.valid;
                 };

                 handleFormChange = () => {
                   this.props.handleFormChange(this.formatData());
                 };
                 radioChange = event => {
                   const name = event.target.name;
                   const value = event.target.value;
                   const updatedFormElement = {
                     ...this.state[name]
                   };
                   this.setState({ ...this.state, grantRadio: { ...this.state.grantRadio, value: value } });
                   if (value === "AOMN") {
                     this.setState({ ...this.state, grantPurpose: { ...this.state.grantPurpose, value: "AOMN" } });
                   } else {
                     this.setState({ ...this.state, grantPurpose: { ...this.state.grantPurpose, value: "" } });
                   }
                   updatedFormElement.value = value;
                   this.setState(
                     {
                       [name]: updatedFormElement
                     },
                     this.handleFormChange
                   );
                 };

                 render() {
                   const {
                     charityName,
                     grantRecognition,
                     grantPurpose,
                     webAddress,
                     phone,
                     ein,
                     charityAllocPercent,
                     contactFirstName,
                     contactLastName,
                     contactEmail
                   } = this.state;
                   return (
                     <div data-test="contentWrapper">
                       {this.props.validateForm && !this.props.charityTotalPercent ? (
                         <ErrMargin className="mt3">Total charity should be 100%</ErrMargin>
                       ) : null}
                       <Row data-test="dataRow">
                         <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                           <InputComponent
                             id="inputCharityName"
                             handleBlur={this.handleBlur}
                             title="Charity Name"
                             arialabel="Enter charity name"
                             placeholder="Enter charity name"
                             name="charityName"
                             handleInputChange={this.handleChange}
                             value={charityName.value}
                           />
                           {this.showError(charityName) ? (
                             <ErrMargin>{charityName.messages[charityName.valid]}</ErrMargin>
                           ) : null}
                         </Col>
                         <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
                           <InputComponent
                              id="inputCharityPercent"
                             handleBlur={this.handleBlur}
                             title="% to grant to charity"
                             placeholder="Enter % to grant to charity"
                             arialabel="Enter % to grant to charity"
                             name="charityAllocPercent"
                             handleInputChange={this.handleChange}
                             value={charityAllocPercent.value}
                           />
                           {this.showError(charityAllocPercent) ? (
                             <ErrMargin>{charityAllocPercent.messages[charityAllocPercent.valid]}</ErrMargin>
                           ) : null}
                         </Col>
                       </Row>
                       <Row>
                         <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                           <InputComponent
                              id="inputCharityEin"
                             title="EIN (Optional)"
                             placeholder="Enter EIN"
                             arialabel="Enter EIN"
                             name="ein"
                             handleInputChange={this.handleChange}
                             value={ein.value}
                           />
                         </Col>
                         <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
                           <InputComponent
                             id="inputPhone"
                             title="Contact Phone Number (Optional)"
                             placeholder="Enter phone number"
                             arialabel="Enter phone number"
                             name="phone"
                             handleInputChange={this.handleChange}
                             value={phone.value}
                           />
                         </Col>
                       </Row>

                       <Row>
                         <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                           <InputComponent
                             id="inputEmail"
                             handleBlur={this.handleBlur}
                             title="Contact Email (Optional)"
                             placeholder="Enter contact email"
                             arialabel="Enter contact email"
                             name="contactEmail"
                             handleInputChange={this.handleChange}
                             value={contactEmail.value}
                           />
                           {this.showError(contactEmail) ? (
                             <ErrMargin>{contactEmail.messages[contactEmail.valid]}</ErrMargin>
                           ) : null}
                         </Col>
                         <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
                           <InputComponent
                             id="inputWeb"
                             title="Contact Web Address (Optional)"
                             placeholder="Enter Web Address"
                             arialabel="Enter Web Address"
                             name="webAddress"
                             handleInputChange={this.handleChange}
                             value={webAddress.value}
                           />
                         </Col>
                       </Row>
                       <Row>
                         <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                           <InputComponent
                             id="inputFirstName"
                             handleBlur={this.handleBlur}
                             title="Contact First Name (Optional)"
                             placeholder="Enter contact first name"
                             arialabel="Enter first name"
                             name="contactFirstName"
                             handleInputChange={this.handleChange}
                             value={contactFirstName.value}
                           />
                           {this.showError(contactFirstName) ? (
                             <ErrMargin>{contactFirstName.messages[contactFirstName.valid]}</ErrMargin>
                           ) : null}
                         </Col>
                         <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
                           <InputComponent
                              id="inputLastName"
                             handleBlur={this.handleBlur}
                             title="Contact Last Name (Optional)"
                             placeholder="Enter contact last name"
                             arialabel="Enter last name"
                             name="contactLastName"
                             handleInputChange={this.handleChange}
                             value={contactLastName.value}
                           />
                           {this.showError(contactLastName) ? (
                             <ErrMargin>{contactLastName.messages[contactLastName.valid]}</ErrMargin>
                           ) : null}
                         </Col>
                       </Row>

                       <Row>
                         <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                           <SelectComponentWrap>
                             <MarginComponentDrop>
                               <SelectComponent
                                 id="slctGrantRecognition"
                                 name="grantRecognition"
                                 title="Grant Recognition"
                                 arialabel="Select Grant Recognition"
                                 placeholder="-Select-"
                                 data={[
                                   { value: "", desc: "--" },
                                   { value: "Anonymous", desc: "Anonymous" },
                                   { value: "Account name only", desc: "Account name only" }
                                 ]}
                                 showArrow={true}
                                 handleInputChange={e => {
                                   this.selectChange(e, "grantRecognition");
                                 }}
                                 value={grantRecognition.value}
                               />
                             </MarginComponentDrop>
                           </SelectComponentWrap>
                           {this.showError(grantRecognition) ? (
                             <ErrMargin>{grantRecognition.messages[grantRecognition.valid]}</ErrMargin>
                           ) : null}
                         </Col>
                         <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
                           <FormItem>
                             <MarginSpecific paddingTop="2px">
                               <EmailWrapper>
                                 <EmailTitleWrapperFont>Grant Purpose</EmailTitleWrapperFont>
                               </EmailWrapper>
                             </MarginSpecific>
                             <RadioButtonWrapper
                               id="rdGrant"
                               name="grantRadio"
                               onChange={this.radioChange}
                               value={this.state.grantRadio.value}
                             >
                               <SpanWrap>
                                 <RadioButton value="AOMN">Area of most need</RadioButton>
                               </SpanWrap>

                               <SpanWrap>
                                 <Radio value="OTHER">Other</Radio>
                               </SpanWrap>
                             </RadioButtonWrapper>
                             {this.state.grantRadio.value === "OTHER" ? (
                               <InputComponent
                                 id="inputGrantPurpose"
                                 placeholder="Enter Grant Purpose"
                                 name="grantPurpose"
                                 handleInputChange={this.handleChange}
                                 value={grantPurpose.value}
                               />
                             ) : null}
                           </FormItem>

                           {this.showError(grantPurpose) ? (
                             <ErrMargin>{grantPurpose.messages[grantPurpose.valid]}</ErrMargin>
                           ) : null}
                         </Col>
                       </Row>
                     </div>
                   );
                 }
               }

               CharityBasicInfo. propTypes = {
                charityData: PropTypes.shape({
                    address: PropTypes.shape({
                      city: PropTypes.string,
                      country: PropTypes.string,
                      line1: PropTypes.string,
                      line2: PropTypes.any,
                      line3: PropTypes.any,
                      state: PropTypes.string,
                      zip: PropTypes.string
                    }),
                    charityAllocPercent: PropTypes.string,
                    contactEmail: PropTypes.string,
                    contactFirstName: PropTypes.string,
                    contactLastName: PropTypes.string,
                    contactPhone: PropTypes.string,
                    ein: PropTypes.string,
                    encryptedEin: PropTypes.any,
                    grantMonth: PropTypes.any,
                    grantPurpose: PropTypes.string,
                    grantRecognition: PropTypes.string,
                    name: PropTypes.string,
                    notes: PropTypes.any,
                    otherGrantPurposeText: PropTypes.string,
                    successionDetailId: PropTypes.number,
                    successionPlanId: PropTypes.number,
                    webAddress: PropTypes.string
                  }),
                  charityTotalPercent: PropTypes.bool,
                  handleFormChange: PropTypes.func,
                legacyFormValid: PropTypes.any,
                validateForm: PropTypes.bool
            };
